// ajax.js

import axios from 'axios';

import { setToken, getToken, removeToken, loginState } from './auth';

import { wafCaptchaManager } from './wafCaptchaManager';

import { cppGetAppInfo } from '../api/cpp';
import { getDeviceId } from './deviceId';
const appInfo = cppGetAppInfo();

let token = getToken() || '';
const LOCAL_BASE = (typeof window !== "undefined" && window.__EM_API_BASE__) || ""
const defaultBaseURL = LOCAL_BASE || "https://api.yuneffect.com"

const overseasBaseURL = "https://api.xsound.cn"

const ajax = axios.create({
    baseURL: defaultBaseURL,
    timeout: 10000,
    withCredentials: true,
})

// IP属地检测：非CN地区切换到海外API
let ipCheckPromise = null;
async function checkIpRegion() {
    try {
        console.log("Checking IP region...");
        const res = await axios.get("https://ipapi.co/json", { timeout: 5000 });
        console.log(JSON.stringify(res.data));
        if (res.data && res.data.country && res.data.country !== "CN") {
            ajax.defaults.baseURL = overseasBaseURL;
        }
    } catch (e) {
        // 检测失败，保持默认地址
    }
}
ipCheckPromise = LOCAL_BASE ? Promise.resolve() : checkIpRegion();

// 拦截全局ajax请求 添加headers，并等待IP检测完成
ajax.interceptors.request.use(async config => {
    await ipCheckPromise;
    config.headers['Content-Type'] = 'application/json'
    config.headers['Accept'] = 'application/json'
    config.headers['Productid'] = (appInfo && appInfo.appId) || ''
    config.headers['Syclient'] = 'SyElectronicMusic/comm/' + (appInfo && appInfo.version)
    config.headers['Deviceid'] = getDeviceId()
    config.headers['token'] = token
    return config
}, error => {
    Promise.reject(error)
})

// 拦截全局ajax response
ajax.interceptors.response.use(res => {
    if (res.headers.token && res.headers.token !== 'invalid') {
        token = res.headers.token
        setToken(token)
    }
    // if (res.data.err === 'ERR_NOT_LOGIN') {
    //     removeToken();
    //     loginState.dispatchState( 'login', res.data );
    //     return res.data;
    // }
    if (res.data.err === 'ERR_NOT_LOGIN' || res.data.err === 'ERR_USER_ALREADY_LOGIN_OTHER_PLACE') {
        removeToken();
        token = "";
        loginState.dispatchState('login', res.data);
    }
    // 被封禁：任何一个接口回了 ERR_USER_DISABLED，就通知界面立刻盖遮罩
    // （不依赖 vipcheck，避免某些功能先跑起来、遮罩还没出现）
    if (res.data.err === 'ERR_USER_DISABLED') {
        try {
            if (typeof window.__onUserDisabled === 'function') {
                window.__onUserDisabled(res.data);
            }
        } catch (e) { }
    }
    return res.data
}, (err) => {
    // 备用地址
    if (!err.response) {
        window.localStorage.removeItem("sy_backup_list_state");
        getUseableBackupUrl((backupUrl, backupList) => {
            if (backupUrl) {
                ajax.defaults.baseURL = backupUrl;
            } else {
                ajax.defaults.baseURL = defaultBaseURL;
            }
            window.localStorage.setItem("sy_backup_list_state", backupList ? "yes" : "no")
        });
        err.message = "Not Response"
        return Promise.reject(err);
    }

    if (err.response && err.response.data && err.response.data.err === 'ERR_CAPTCHA_REQUIRED') {
        // 需要验证码触发
        const targetPath = err.response.config.url;
        wafCaptchaManager.setTargetPath(targetPath);
        wafCaptchaManager.setNeedCaptcha(true);
        return new Promise((resolve, reject) => {
            err._captchaResolve = resolve;
            err._captchaReject = reject;
            wafCaptchaManager.addPendingRequest(err);
        });
    } else if (err.response && err.response.data && err.response.data.err === 'ERR_RATE_LIMIT_EXCEEDED') {
        const message = '请求过于频繁，请稍后重试';
        wafCaptchaManager.setShowRateLimit(true, message);
    } else if (err.response && err.response.data && err.response.data.err === 'ERR_IP_BLOCKED') {
        const message = '请求被禁止，请稍后重试';
        wafCaptchaManager.setShowRateLimit(true, message);
    } else if (err.response && err.response.data && err.response.data.err === 'ERR_IP_BLOCKED_TEMP') {
        const message = '请求被临时禁止，请稍后重试';
        wafCaptchaManager.setShowRateLimit(true, message);
    }
    return Promise.reject(err);
});

// 获取一个可用的备用地址
let timer = null;
async function getUseableBackupUrl(cb) {
    if (timer) {
        clearTimeout(timer);
    }
    timer = window.setTimeout(async ()=> {
        const backupList = await getBackupList();
        console.log("备用地址列表：", backupList)
        const useableUrl = await checkUrls(backupList);
        cb(useableUrl, backupList)
    }, 1000)
}

// 获取备用列表
async function getBackupList() {
    try {
        const cnfJson = await axios("https://em.yuneffect.com/emusic3web/cnf.json");
        const backupList = await axios(cnfJson.data.backupList);
        if (backupList && Array.isArray(backupList.data)) {
            // 将overseasBaseURL添加到备用列表中
            backupList.data.push(overseasBaseURL)
            return backupList.data
        }
        return [overseasBaseURL]
    } catch (error) {
        // 获取备用列表失败 则只使用overseasBaseURL
        return [overseasBaseURL]
    }
}

// 检测备用列表 返回第一个可用的URL 如果没有则返回空
async function checkUrls(urlList) {
    if (!urlList) {
        return ""
    }
    try {
        for (const urlItem of urlList) {
            try {
                if (urlItem.includes(overseasBaseURL)) {
                    // 特殊处理 这个地址不做心跳检测 直接使用
                    return `${urlItem}`;
                }
                const valid = await axios(`${urlItem}/heartbeat`);
                if (valid && valid.status === 200) {
                    return `${urlItem}`;
                }
            } catch (err) {
            }
        }
    } catch (error) {
        return ""
    }
    return ""
}

export default ajax
